import Vue from "vue";
import { mixins } from "vue-class-component";
import Component from "vue-class-component";
import { RapportFav, Rapport } from "@/shared/Rapport";
import { Site } from "@/shared/Site";
import { Groupe } from "@/shared/Groupe";
import PdfReport from "@/shared/pdfReport";
import MobileMixin from "@/mixins/mobileMixin";
import ErrorMixin from "@/mixins/errorMixins";
import { TypeRapport } from "@/shared/Rapport";
import moment from "moment/moment";
import { Enseigne } from "@/shared/Enseigne";

declare let cordova: any;

// You can declare a mixin as the same style as components
@Component
export default class RapportMixin extends mixins(MobileMixin, ErrorMixin) {
  public restaurantIds_to_enseigne: any = {};
  public monrapport: Rapport = new Rapport();
  public avReports: any = { PDF_AVAILABLE: false, CSV_AVAILABLE: false };
  public dialogError: boolean = false;
  public showRep = false;
  public pdfReport: PdfReport = new PdfReport();
  public monFiltre: string = "";
  public monTri: string = "";
  public selectedCondition: string = "";
  public selectedMultiCondition: string[] = [];
  public conditions: string[] = [];
  public extensionRapport: string = "";
  public cumulReport = true;
  public listError = new Array();
  public searchTerm: string = "";
  public conditionsCopy: string[] = [];

  /**
   * mise à jour du type de site ou groupe pour le rapport favori selectionné
   */
  public updateType(type: string) {
    Vue.set(this.monrapport, "typeSite", type);
    this.monrapport.typeSite = type;
  }
  /*
   * methode de selection d'un rapport
   */
  public typeRapportSelected(evt: any) {
    // console.log(evt);
    // console.log(this.avReports);
    // console.log(this.monrapport);
    this.monrapport.typeRapport = evt;
    this.updateRapport(this.monrapport);
  }
  /**
   * methode de mise à jour du vendeur sélectionné
   * @param vendeur le vendeur à selectionner / deselectionner
   */
  public updateVendeur(vendeur: any) {
    // console.log(vendeur);
    if (vendeur !== "") {
      this.monrapport.vendeur = vendeur;
    } else {
      this.monrapport.vendeur = undefined;
    }
    this.monrapport.lCaisses = new Array();
    // console.log(this.monrapport);
    this.updateRapport(this.monrapport);
  }
  /**
   * mise à jour du groupe à interroger pour  le rapport favori selectionné
   */
  public selectGroupe(groupe: Groupe) {
    this.monrapport.groupement = new Array();
    this.monrapport.groupement.push(groupe);
  }
  /*
   * methode de mise à jour des caisses selectionnées
   */
  public updateCaisses(caisses: any) {
    this.monrapport.vendeur = undefined;
    this.monrapport.lCaisses = caisses;
    this.updateRapport(this.monrapport);
  }
  /**
   * methode de mise a jour de la date
   */
  public updateDate(rapport: any) {
    if (this.monrapport && this.monrapport.periode) {
      this.monrapport.periode = rapport.periode;
      this.monrapport.typePeriode = rapport.typePeriode;
      this.updateRapport(this.monrapport);
    } else {
      this.monrapport = rapport;
    }
  }

  public addSites(sites: Site[]) {
    this.monrapport.lSites = sites;
    this.updateRapport(this.monrapport);
  }
  /**
   * mise a jour des sites du monrapport
   */
  public addSite(site: Site) {
    const index = this.monrapport.lSites.findIndex(
      (monsite: Site) => monsite.restaurantId === site.restaurantId
    );
    if (index === -1) {
      Vue.set(this.monrapport.lSites, this.monrapport.lSites.length, site);
    } else {
      this.monrapport.lSites = this.monrapport.lSites.filter(
        (msite: Site) => msite.restaurantId !== site.restaurantId
      );
    }
    this.updateRapport(this.monrapport);
  }
  /*
   * methode de selection ou deselection d'un site depuis la fenetre de dialogue
   * @param {Site} site- le site à selectionner
   */
  public removeSite(site: Site) {
    this.addSite(site);
  }
  /*
   * methode de mise a jour du rapport selectionné dans la page parente
   */
  public updateRapport(rapport: Rapport | RapportFav) {
    this.$emit("updateRapport", rapport);
  }
  /**
   * methde permettant d'enregistrer un rapport favoris
   */
  public save() {
    this.$emit("save", this.monrapport);
  }
  /**
   * methode de selection des types de monrapports disponibles
   */
  public selectRapport(result: any) {
    // console.log("selected");
    this.avReports = result;
    // console.log(result);
  }

  public updateTris() {
    this.monrapport.tri = this.monTri;
  }
  public updateFiltres() {
    this.monrapport.filtre = this.monFiltre;
    this.$store
      .dispatch("rapport/getFilter", {
        rapportGeneralClassName: this.monrapport.typeRapport.className,
        filter: this.monFiltre,
        restaurantId: this.monrapport.lSites.length > 0 ? this.monrapport.lSites[0].restaurantId : -1,
        dateDebut: this.monrapport.dateDebutEnvoi,
        dateFin: this.monrapport.dateFinEnvoi,
      })
      .then((other: string[]) => (this.conditions = other));
  }
  /*public updateTris(){
    this.monrapport.tri = this.monTri;
  }*/
  public updateSaveConditions(values: any) {
    this.monrapport.condition = values;
    this.selectedMultiCondition = values;
  }

  public compareConditions() {
    return this.conditions.filter((value) => this.selectedMultiCondition.includes(value));
  }
  public updateConditions() {
    if (this.avReports.MULTI_CHOIX_FILTRES) {
      this.monrapport.condition = this.compareConditions();
    } else {
      this.monrapport.condition = [];
      this.monrapport.condition.push(this.selectedCondition);
    }
  }

  public async genererRapport(format?: string, isRecurrence?: boolean) {
    if (this.avReports.MAX_DAYS && this.avReports.MAX_DAYS !== -1) {
      const diffDay =
        moment(this.monrapport.dateFin).diff(
          moment(this.monrapport.dateDebut),
          "days"
        ) + 1;

      if (diffDay > this.avReports.MAX_DAYS) {
        const txt =
          this.$t("MaxReportDays").toString() + " : " + this.avReports.MAX_DAYS;
        this.setErrorFromTxt(txt);
        return;
      }
    }

    // Vérification du nombre de sites sélectionnés
    if (this.monrapport.lSites.length !== 1 && this.avReports.MULTI_SITES === false) {
      const txt = this.$t("multiSitesTooMuch").toString();
      this.setErrorFromTxt(txt);
      return;
    }

    if (format) {
      this.monrapport.format = format;
    } else {
      this.monrapport.format = "PDF";
    }
    this.updateRapport(this.monrapport);
    if (isRecurrence) {
      return;
    }

    if (this.monrapport.typeRapport.className === "") {
      await this.$store.dispatch("login/setLoading", false);
      this.dialogError = true;
    } else {
      try {
        if (this.isMobile() || this.isElectron() || this.isApp) {
          await this.makeReportMobile();
        } else {
          await this.makeReport(format);
        }
      } catch (error) {
        console.error("Erreur lors de la génération du rapport : ", error);
        this.dialogError = true;
        await this.$store.dispatch("login/setLoading", false);
      }
    }
  }

  public created() {
    const enseignes = this.enseignes;
    enseignes.forEach((enseigne: Enseigne) => {
      this.restaurantIds_to_enseigne[enseigne.restaurantId] = enseigne.libelle;
    });
  }

  public async makeReport(format?: string) {
    // Active le chargement au début de la fonction
    await this.$store.dispatch("login/setLoading", true);

    try {
      if (this.cumulReport) {
        const url =
          this.client === "TOTAL"
            ? "rapport/getReportTotal"
            : "rapport/getReport";

        const res = await this.$store.dispatch(url);

        if (res.data.size === 0) {
          this.setErrorInside({
            message: this.$t("CheckReportParam").toString(),
          });
          return;
        }
        if (res.status === 409) {
          this.setErrorInside(res);
          return;
        }

        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });

        this.extensionRapport = res.headers["content-type"];
        const bloburl = (window.URL || window || {}).createObjectURL(blob);
        this.pdfReport.src = bloburl;
        const titre = this.setRapportTitre();
        this.pdfReport.titre = titre;

        const fileLink = document.createElement("a");
        fileLink.href = bloburl;
        fileLink.setAttribute("download", titre);
        document.body.appendChild(fileLink);
        fileLink.click();
      } else {
        for (const site of this.monrapport.lSites) {
          await this.getSingleRap(site);
        }
      }
    } catch (err: any) {
      console.error("Erreur lors de la génération du rapport : ", err);

      const fr = new FileReader();
      let message;

      fr.onload = () => {
        message = fr.result;
        if (message) {
          try {
            message = JSON.parse(message.toString());
          } catch (errorType) {
            this.setError(err);
          }
        }
        this.setErrorInside(message);
      };

      if (err.response && err.response.data) {
        fr.readAsText(err.response.data);
      }
    } finally {
      // Désactive le chargement dans tous les cas (succès ou échec) mais seulement à la fin
      await this.$store.dispatch("login/setLoading", false);
    }
  }

  public async makeReportMobile() {
    // Active le chargement au début de la fonction
    await this.$store.dispatch("login/setLoading", true);

    try {
      if (this.cumulReport) {
        const res = await this.$store.dispatch("rapport/getReport");

        if (res.status === 409) {
          this.setErrorFromTxt(res.message);
          return;
        }

        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });

        let bloburl;
        if (window.URL == null) {
          // Dans le cas où window.URL n'est pas défini
          bloburl = localStorage.ip.createObjectURL(blob);
        } else {
          bloburl = window.URL.createObjectURL(blob);
        }

        this.pdfReport.src = bloburl;
        this.pdfReport.titre = this.setRapportTitre();
        this.showRep = true;
      } else {
        for (const site of this.monrapport.lSites) {
          await this.getSingleRapMobile(site);
        }
        this.setSuccess("Rapports téléchargés dans vos fichiers.");
      }
    } catch (err: any) {
      const fr = new FileReader();
      let message;

      fr.onload = () => {
        message = fr.result;
        if (message) {
          try {
            message = JSON.parse(message.toString());
          } catch (error) {
            this.setError(err);
          }
        }
        this.setError(message);
      };

      if (err.response && err.response.data) {
        fr.readAsText(err.response.data);
      } else {
        // Les erreurs sans réponse structurée
        this.setErrorInside("Une erreur est survenue lors de la génération du rapport.");
      }
    } finally {
      // Désactiver le chargement dans tous les cas (succès ou échec)
      await this.$store.dispatch("login/setLoading", false);
    }
  }

  /**
   * methode permettant de déterminer le titre du rapport téléchargé
   */
  public setRapportTitre(siteName?: string): string {
    let titre = this.monrapport.typeRapport.localisedTitle;
    let dates = this.monrapport.dateDebutEnvoi;
    if (this.monrapport.dateFinEnvoi !== this.monrapport.dateDebutEnvoi) {
      dates += "_" + this.monrapport.dateFinEnvoi;
    }
    titre += "_" + dates;
    if (
      this.monrapport.vendeur !== "" &&
      this.monrapport.vendeur !== undefined
    ) {
      titre = "vendeur_" + this.monrapport.vendeur + "_" + titre;
    }
    if (siteName !== undefined && siteName !== "") {
      titre = siteName + "_" + titre;
    } else {
     /* if (!Array("TOTAL", "BK", "BUFFALO").includes(this.client)) {
        let libelles = "";
        let firstIteration = true;
        const isMultiSites = this.monrapport.lSites.length > 1;
        this.monrapport.lSites.forEach((element) => {
            if (firstIteration) {
              if (isMultiSites) {
                libelles += `${this.restaurantIds_to_enseigne[element.restaurantId]}-${element.libelle}`;
              } else {
                libelles += `${element.libelle}`;
              }
              firstIteration = false;
            } else {
                libelles += ` ${this.restaurantIds_to_enseigne[element.restaurantId]}-${element.libelle}`;
            }
        });
        titre = libelles + "_" + titre;
      } else {*/
        let libelles = "";
        const isMultiSites = this.monrapport.lSites.length > 1;
        if (isMultiSites) {
          titre = this.$t("multiSites").toString() + "_" + titre;
        } else {
          this.monrapport.lSites.forEach((element) => {
            libelles += `${element.libelle}`;
          });
          titre = libelles + "_" + titre;
        }
      // }
    }

    let extension = "pdf";
    if (this.monrapport.format === "CSV") {
      if (this.extensionRapport.includes("zip")) {
        extension = "zip";
      } else {
        extension = "csv";
      }
    }
    titre += "." + extension;
    return titre;
  }
  /**
   * methode de traduction d'un className en localisedTitle
   * @param className la className à traduire
   * @returns le localisedTitle
   */
  public getReportbyClassName(className: string) {
    let localisedTitle = "";
    Object.keys(this.listeRapports).forEach((k: string) => {
      const typeRep = this.listeRapports[k];
      typeRep.forEach((rap: TypeRapport) => {
        if (rap.className === className) {
          localisedTitle = rap.localisedTitle;
        }
      });
    });
    return localisedTitle;
  }

  public setErrorInside(error: any) {
    let message;
    if (error.message) {
      message = error.message;
      this.setErrorFromTxt(message, this.$t("ErrorUnknownRap").toString());
    } else {
      message = this.$t("ErrorUnknownRap").toString();
      this.setErrorFromTxt(message);
    }
    this.$store.dispatch("login/setLoading", false);
  }

  private async getSingleRap(site: Site) {
    console.log(site);
    return await this.$store
      .dispatch("rapport/getReportIndividuel", site.restaurantId)
      .then(
        (res: any) => {
          if (res.data.size === 0) {
            this.setErrorInside({
              message: this.$t("CheckReportParam").toString(),
            });
            return;
          }
          if (res.status === 409) {
            this.setErrorInside(res);
            return;
          }
          const blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          this.extensionRapport = res.headers["content-type"];
          const bloburl = (window.URL || window || {}).createObjectURL(blob);
          this.pdfReport.src = bloburl;
          const titre = this.setRapportTitre(site.libelle);
          this.pdfReport.titre = titre;
          const fileLink = document.createElement("a");
          fileLink.href = bloburl;
          fileLink.setAttribute("download", titre);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        },
        (err: any) => {
          this.listError.push(site);
          const fr = new FileReader();
          let message;
          const ethis = this;
          fr.onload = () => {
            message = fr.result;
            if (message) {
              message = JSON.parse(message.toString());
            }
            ethis.setErrorInside(message);
          };
          fr.readAsText(err.response.data);
        }
      );
  }

  private async getSingleRapMobile(site: Site) {
    console.log(site);
    return await this.$store
      .dispatch("rapport/getReportIndividuel", site.restaurantId)
      .then(
        (res: any) => {
          if (res.data.size === 0) {
            this.setErrorInside({
              message: this.$t("CheckReportParam").toString(),
            });
            return;
          }
          if (res.status === 409) {
            this.setErrorInside(res);
            return;
          }
          this.$store.dispatch("login/setLoading", true);
          const blob = new Blob([res.data], {
            type: res.headers["content-type"],
          });
          const bloburl = (window.URL || window || {}).createObjectURL(blob);
          const destination = this.isiOS() ? cordova.file.documentsDirectory : cordova.file.externalDataDirectory;

          window.resolveLocalFileSystemURL(destination, (dir: any) => {
            dir.getFile("downloadedFile.pdf", { create: true }, (file: any) => {
              file.createWriter((fileWriter: any) => {
                fileWriter.write(encodeURI(bloburl));
                fileWriter.onwriteend = () => {
                  console.log("Download complete: " + file.toURL());
                };
                fileWriter.onerror = (error: any) => {
                  console.log("Error writing file: " + error.toString());
                };
              });
            });
          });

          const titre = this.pdfReport.titre;

          // Convert the blob URL to a Blob object
          fetch(bloburl)
            .then((response) => response.blob())
            .then((data) => {
              // Create a FileReader to read the Blob data
              const reader = new FileReader();
              reader.onloadend = () => {
                // Get the Blob as a data URL
                const dataUrl = reader.result;

                // Share the file via the iOS Share Sheet
                window.plugins.socialsharing.share(
                  titre, // Message
                  null, // Subject (optional)
                  dataUrl, // File data
                  null, // URL (optional)
                  () => {
                    console.log("File shared successfully");
                  },
                  (error: any) => {
                    console.error("Error sharing file: " + error);
                  }
                );
              };
              // Read the Blob data as a data URL
              reader.readAsDataURL(data);
            })
            .catch((error) => {
              console.error("Error downloading Blob: " + error);
            });
        },
        (err: any) => {
          this.listError.push(site);
          const fr = new FileReader();
          let message;
          const ethis = this;
          fr.onload = () => {
            message = fr.result;
            if (message) {
              message = JSON.parse(message.toString());
            }
            ethis.setErrorInside(message);
          };
          fr.readAsText(err.response.data);
        }
      );
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }

  get isApp(): boolean {
    return this.$store.getters["getApp"];
  }

  get listeRapports() {
    return JSON.parse(localStorage.allReports);
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
